import { useShallow } from 'zustand/react/shallow';

import { Steps, Timer } from '@/components/StickyNavigation';
import { SESSION_EXPIRED_ERROR } from '@/constants';
import { NavigationStepEnum } from '@/constants/navigation';
import useInvalidSessionRedirect from '@/hooks/useInvalidSessionRedirect';
import { useClearSession } from '@/hooks/useSession';
import { usePrenuvoStore } from '@/stores/usePrenuvoStore';

export default function NavigationDetails() {
  const { session, clearScan, setErrorModal } = usePrenuvoStore(
    useShallow((state) => ({
      session: state.scan.session,
      clearScan: state.scan.methods.clearScan,
      setErrorModal: state.ui.methods.setErrorModal,
    })),
  );
  const { trigger: triggerClearSession } = useClearSession();
  const { label: currentStepLabel } = useInvalidSessionRedirect();

  const onHoldTimerEnd = () => {
    triggerClearSession();
    clearScan();
    if (currentStepLabel === NavigationStepEnum.SCAN_DETAILS) {
      setErrorModal(SESSION_EXPIRED_ERROR.title, SESSION_EXPIRED_ERROR.message);
    }
  };

  return (
    <div className="mb-3 flex flex-col gap-y-1 text-inactive sm:flex-row sm:items-end md:mb-0">
      <div className="flex justify-between sm:flex-col">
        <span className="md:col-span-2">{currentStepLabel}</span>

        <Steps />
      </div>
      {session?.sessionStartTimestamp && (
        <Timer onTimerEnd={onHoldTimerEnd} utsStart={session.sessionStartTimestamp} />
      )}
    </div>
  );
}
